import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';

/**
 * Single source of truth for the `feature-use-sip-events-for-failed-tasks` gate.
 *
 * Two handlers depend on this being mutually exclusive: `handleCallFailedGeneral`
 * runs only when it is ON, `handleCallMissed` runs only when it is OFF. Keeping
 * the key (and any future compound condition) in one place stops the two
 * inverted checks from silently drifting apart.
 */
export function sipEventsForFailedTasksEnabled(): boolean {
  return FeatureFlagModule.isEnabled(
    FeatureFlagKeys.featureUseSipEventsForFailedTasks,
  );
}
